module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "qhkh"
    }
  }, [_c('header', {
    staticClass: "am-topbar"
  }, [_c('OffCanvas', {
    staticClass: "meun"
  }, [_vm._v("边侧栏")]), _vm._v(" "), _vm._m(0)], 1), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "text"
  }, [_vm._v("\n    东航金融App 由央企东航集团旗下金融机构东航金融联合东航期货、东航国际金融（香港）等共同研发，以期货投资为特色，涵盖私募资管等业务。功能包括手机开户、行情交易、交易策略、数据分析、私募基金、组合配置、各类计算等。是业内领先的智能金融移动工具。\n\n  ")]), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('ICP')], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-wrapper"
  }, [_c('div', {
    staticClass: "logo"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "down-wrapper"
  }, [_c('div', {
    staticClass: "dhqh"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("东航期货APP")]), _vm._v(" "), _c('a', [_vm._v("点击下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "down-wrapper"
  }, [_c('div', {
    staticClass: "qhykh"
  }), _vm._v(" "), _c('div', {
    staticClass: "title"
  }, [_vm._v("期货开户云APP")]), _vm._v(" "), _c('a', [_vm._v("点击下载")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text"
  }, [_c('p', [_vm._v("期货互联网开户云APP是中国期货市场监控中心通过云技术，为期货公司提供免费的互联网开户业务。")]), _vm._v(" "), _c('p', [_vm._v("投资者可使用该APP办理期货网上开户业务，目前支持大连商品交易所，郑州商品交易所，上海期货交易所和中国金融期货交易所的自然人客户（限中国大陆居民）开户功能。")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-60aa4376"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/qhkh/qhkh.vue
// module id = 892
// module chunks = 2